import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell, LabelList,
} from 'recharts';
import DashboardCard from './DashboardCard';
import { BRAND } from '../styles';
import { formatPercent, slaBreachColor, formatNumber } from '../constants';

// Kart 4/7 — SLA ihlali: aşama başına ihlal oranı, bar grafik, oran
// yükseldikçe uyarı rengi (brief). `rate` payda sıfırken backend `null`
// döner — grafikte yükseklik 0 (aynı görsel bir gerçek %0 ile), ama üstteki
// etiket her zaman gerçek değeri taşır: null → "—", asla "%0" (formatPercent).
export default function SlaBreachCard({ data, loading }) {
  const { t, i18n } = useTranslation();

  const rows = useMemo(() => (
    [...(data || [])]
      .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
      .map((row) => ({ ...row, chartValue: row.rate === null || row.rate === undefined ? 0 : row.rate * 100 }))
  ), [data]);

  return (
    <DashboardCard
      cardKey="sla-ihlali"
      title={t('atsDashboard.slaBreach.title')}
      meta={t('atsDashboard.slaBreach.meta')}
      span={6}
      spanMd={6}
      loading={loading}
      empty={rows.length === 0}
      domId="ats-dash-sla-breach"
    >
      <ResponsiveContainer width="100%" height={200}>
        <BarChart data={rows} margin={{ top: 16, right: 4, bottom: 0, left: 4 }}>
          <XAxis
            dataKey="stageName"
            tickLine={false}
            axisLine={{ stroke: BRAND.border }}
            tick={{ fontSize: 10, fill: '#6B7280' }}
          />
          <YAxis hide domain={[0, 100]} />
          <Tooltip
            cursor={{ fill: 'rgba(2, 211, 191, 0.06)' }}
            formatter={(_value, _name, entry) => [
              t('atsDashboard.slaBreach.breachedOfTotal', {
                breached: formatNumber(entry.payload.breached, i18n.language),
                total: formatNumber(entry.payload.total, i18n.language),
              }),
              formatPercent(entry.payload.rate, i18n.language),
            ]}
          />
          <Bar dataKey="chartValue" barSize={28} radius={[4, 4, 0, 0]}>
            {rows.map((row) => (
              <Cell key={row.stageId} fill={slaBreachColor(row.rate)} />
            ))}
            <LabelList
              dataKey="rate"
              position="top"
              formatter={(v) => formatPercent(v, i18n.language)}
              style={{ fill: BRAND.textDark, fontSize: 11, fontWeight: 700 }}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </DashboardCard>
  );
}
